<template>
  <div id="container">
    <div id="loading" class="hide">
      <div class="commonDialog zIdx99999 " >
        <img class="width110 loaddingImg" src="../static/images/loading.gif"/>
      </div>
    </div>
    <div id="polling" class="hide">
      <div class="commonDialog zIdx99999 " >
        <img class="width110 loaddingImg" src="../static/images/loading.gif"/>
      </div>
    </div>
    <div class="commonDialog" v-if="channelConfig.displayProtocol">
      <div class="widthPercent100 ">
        <div  class="commonDialogContent">
          <div class="commonDialogContentHead borderBotE5 backF5">
            <span class="color21 size16 font500">用户服务协议</span>
          </div>
          <van-form ref="ruleForm">
            <div class="marLR20 borderBotDfe marTop10">
              <van-field class="color21" icon-prefix="iconfont" left-icon="iconfont iconbangdingshouji color40 size16"
                         v-model="ruleForm.tel" type="digit" maxlength="11" :rules="telRules" name="mobile" placeholder="请输入手机号"/>
            </div>
            <div class="marLR20 marTop10">
              <van-field class="color21 Yflex" icon-prefix="iconfont"
                         left-icon="iconfont iconyanzhengma1 size16 color40"
                         v-model="ruleForm.code" :rules="codeRules" maxlength="4" type="digit"
                         placeholder="请输入验证码">
                <template #button>
                  <span class="pointer" @click="sendCode" :class="verfDisabled ? 'color99' : 'color40'">{{verfCont}}</span>
                </template>
              </van-field>
            </div>
          </van-form>
          <div class="flex marLR20 marTop20 size14">
            <van-checkbox class="color99" v-model="protocolChecked" :checked-color="mainColor">已阅读并同意</van-checkbox>
            <span class="themeColor pointer" @click="protocolContentBool = true">《用户服务协议》</span>
          </div>
          <div class="marLR20 marTop30 marBott30">
            <van-button type="primary" :disabled="!protocolChecked" @click="protocolFn" class="widthPercent100 back40 borderNone">确定</van-button>
          </div>
        </div>
      </div>
    </div>
    <div class="commonDialog" v-if="protocolContentBool">
      <div class="widthPercent100 " >
        <div  class="commonDialogContent">
            <div v-html="channelConfig.displayProtocolContext" class="protocolTxt"></div>
            <div @click="protocolContentBool = false"  class="commonDialogBottomBtn size16 textCenter pointer">关闭</div>
        </div>
      </div>
    </div>
    <div class="fixed-box">
      <div class="fixed-box-main">
        <pp class="marBott20" v-if="chatServicePic && !routePath" :chatServicePic="chatServicePic"></pp>
        <goHome v-if="goHomeShow"></goHome>
        <!-- <div class="color66 box"></div>
        <div class="color66 box"></div> -->
      </div>
    </div>
    <keep-alive :include="include">
      <router-view v-if="$route.meta.keepAlive" v-wechat-title='$route.meta.title'/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" v-wechat-title='$route.meta.title'/>
  </div>
</template>

<script>
import VantForm from './components/common/form';
import ChannelConfig from "./public/ChannelConfig";   // 渠道信息变量
import quoteVehicleInfo from "./public/QuoteVehicleInfo";
import goHome from "./components/base/goHome.vue"
import pp from "./components/base/pp.vue"
export default {
  name: 'App',
  data() {
    return {
      include: [],
      theme: "blue",
      themeColor: "",
      themeList: quoteVehicleInfo.theme,
      orderId: '',
      channelCode: '',
      mainColor: this.$store.state.themeMainColor,
      channelConfig: JSON.parse(JSON.stringify(ChannelConfig)),   // TODO 渠道信息变量
      protocolChecked: false,
      protocolContentBool: false,
      verftype: 'info',
      verfCont: '获取验证码',
      verfDisabled: false,
      verfBool: null,
      ruleForm: {
        tel: '',
        code: '',
      },
      telRules: [{
        required: true,
        message: '手机号码不能为空',
        trigger: 'onBlur'
      }, {
        // 自定义校验规则
        validator: value => {
          return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
            .test(value)
        },
        message: '请输入正确格式的手机号码',
        trigger: 'onBlur'
      }],
      codeRules: [{
        required: true,
        message: '验证码不能为空',
        trigger: 'onBlur'
      }]
    }
  },
  watch: {
    $route(to, from) {
//      console.log(to.meta.deepth)
//      console.log(from.meta.deepth)
      // 如果要to(进入)的页面是需要keepAlive缓存的，把name push进include数组中
      if (to.meta.keepAlive) {
        !this.include.includes(to.name) && this.include.push(to.name);
      }
      // 如果 要 form(离开) 的页面是 keepAlive缓存的，
      // 再根据 deepth 来判断是前进还是后退
      // 如果是后退：
      if (from.meta.keepAlive && to.meta.deepth < from.meta.deepth) {
        const index = this.include.indexOf(from.name);
        index !== -1 && this.include.splice(index, 1);
      }
    }
  },
  created() {
    if (!sessionStorage['tips']) {
      sessionStorage['tips'] = JSON.stringify(['0', '0', '0', '0', '0'])
    }
    this.channelConfig = sessionStorage['channelConfig'] ? JSON.parse(sessionStorage['channelConfig']) : '';
    this.orderId = this.commonJs.getQueryString('orderId') || this.$route.query.orderId;
    this.channelCode = this.commonJs.getQueryString('channelCode') || this.$route.query.channelCode || sessionStorage['channelCode'];
    this.getChannelData(this.orderId, this.channelCode)
    this.commonJs.theme('');
  },
  computed: {
    goHomeShow() {
      return this.$store.state.goHomeShow && ['/home', '/myOrder'].includes(this.$route.path)
    },
    chatServicePic() {
      return this.$store.state.chatServicePic
    },
    routePath() {
      return this.$route.path === '/myOrder'
    },
  },
  methods: {
    getChannelData(orderId, channelCode) {
      this.$http.post('/vehicle/loadChannelConfig', {orderId, channelCode}).then(res => {
        if (!res) return
        this.$store.commit("setChannelData", res.data.body)
        if (res.data.body.chatServicePic) this.$store.commit("setChatServicePic", res.data.body.chatServicePic)
      })
    },
    loadChannelConfig() {
      let url = `/vehicle/loadChannelConfig`
      this.$http.post(url, {channelCode: this.channelCode}).then(res => {
        if (!res) return
        // store.commit("quoteVehicleInfo",res.data.body)
        let data = res.data.body;
        sessionStorage['channelCode'] = data.channelCode
        sessionStorage['channelConfig'] = JSON.stringify(data)
        this.commonJs.theme(data.skinCss);
        this.channelConfig = data
      })
    },
    // 同意用户服务协议
    protocolFn() {
      this.$refs.ruleForm.validate().then(() => {
        let url = `/vehicle/chkVehicleAuth`
        this.$http.post(url, this.ruleForm).then(res => {
          if (!res) return
          this.loadChannelConfig()
        })
      }).catch(() => {
        this.$notify({
          message: '请填写必要的信息',
          type: 'warning',
        });
      })
    },
    // 发送验证码
    sendCode() {
      if (this.verfDisabled) return
      this.$refs.ruleForm.validate('mobile').then(() => {
        let url = `/vehicle/sendVehicleAuth`
        this.$http.post(url, this.ruleForm).then(res => {
          if (!res) return
          this.time(60)
        })
      }).catch(() => {
        this.$notify({
          message: '请填写正确手机号',
          type: 'warning',
        });
      })
    },
    time(w) {
      if (w == 0) {
        this.verfDisabled = false;
        this.verftype = 'info';
        this.verfCont = '获取验证码';
      } else {
        this.verftype = 'info';
        this.verfDisabled = true;
        this.verfCont = "重新发送(" + w + ")";
        w--;
        this.verfBool = setTimeout(() => {
          this.time(w);
        }, 1000)
      }
    },
  },
  components: {
    VantForm,
    goHome,
    pp
  }
}
</script>

<style lang='scss'>
@import "./scss/_handle.scss";
.protocolTxt{
  overflow-x:hidden;
  overflow-y:auto;
  max-height:600px;
  padding: 16px;
}
.loaddingImg{
  margin-top:-220px;
}
.themeColor {
  color: $mainColor !important;
}
.bgColor {
  background-color: $mainColor !important;
}
.bordergColor {
  border: .1rem solid $mainColor !important;
}
.fixed-box {
  position: fixed;
  bottom: 80px;
  right: -32px;
  z-index: 102;
  .fixed-box-main{
    display: flex;
    flex-direction: column;
    .box{
      width: 68px;
      height: 68px;
      background: red;
      border-radius: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue